<div class="main">
  <header-menu></header-menu>

  <div class="colab-manager-wrapper">
    <div class="content colab-manager-content no-padding">
      <div class="colab-manager-content-component fade-in-animation">

        <breadbrumbs [items]="breadcrumbItems" ></breadbrumbs>

        <h1>Conheça as regras</h1>

        <div class="title">Como funciona?</div>

        <p>O funcionamento da premiação é muito simples: você compartilha seu link de indicação para fazer parte da
          Allya com quantos amigos quiser da sua empresa.</p>

        <p>Quando 3 indicações se cadastrarem por meio do seu link, você é premiado com um voucher de R$ 15 para
          utilizar no iFood!</p>

        <p>Seus amigos indicados que se cadastrarem através do seu link de convite também ganham o mesmo valor de R$ 15
          para usar como quiserem no iFood. Simples né?</p>

        <div class="title">Regras gerais</div>

        <p>A promoção atual está em vigência de 31/08/2021 a 30/09/2021</p>
        <p>Quando 3 indicados da sua empresa se cadastrarem por meio do seu link de convite, você recebe um voucher de R$ 15 para utilizar no iFood.</p>
        <p>O indicado da sua empresa que se cadastrar através do seu link de convite também recebe um voucher de R$ 15 para usar no iFood.</p>
        <p>Não serão contabilizados e premiados os indicados que se cadastrarem fora do seu link de convite.</p>
        <p>Os indicados devem fazer parte da sua empresa.</p>
        <p>Não há limites de indicação. Por isso, indique quantos amigos da sua empresa você quiser. Quanto mais amigos indicar, maior sua chance de ser premiado.</p>
        <p>Para a liberação do voucher, são considerados apenas os indicados que se cadastrarem durante o período da promoção (de 31/08/2021 a 30/09/2021).</p>
        <p>A validade do voucher de R$ 15 para gastar no iFood é de 2 meses.</p>
      </div>
    </div>
  </div>

</div>
